import {
	moveHamburgerToNavigationButtons,
	moveLoginToNavigationButtons,
	setHeaderTopHeightVariable,
	moveTopNavToNavigationMobile,
	setStickyHeader,
	moveBannerToMenu,
	createMenuLevel2Wrap,
	createMenuLevel2Headers,
	moveNavigationToHeaderTop,
	handleTopBarCurrency,
} from '../modules/header'
import { createCarouselDots } from '../modules/carousel'
import { createElement, handleContactForm } from '../modules/globalFunctions'
import {
	makeFilterTitlesClickable,
	createShowSubcategoriesButton,
	categoryHead,
	handleFiltersAndBtn,
	handleFiltersInSpecialCategory,
	handleTopProducts,
} from '../modules/category'
import {
	handleProductTop,
	createAddToCartWrapper,
	turnProductImgToCarousel,
	handleFavoritesIcon,
	moveFlagsToImage,
	createProductInfoWrapper,
	createDeliveryWrapper,
	variantsHandler,
	handlePDescLink,
	appendflagsExtraToFlags,
	handleThumbnailArrows,
} from '../modules/productDetail'
import { addLinkToArticles, moveBlogTimeToImg } from '../modules/blog'
import { handleBrandsPageTop } from '../modules/brands'

window.language = dataLayer[0].shoptet.language

// COMONLY USED
// HEADER
const addTextToTopNav = () => {
	const topNavigationTools = document.querySelector('.top-navigation-tools')
	if (!topNavigationTools) return
	if (typeof textNahoreOtvoreno === 'undefined' || textNahoreOtvoreno === '') return
	const createText = createElement('div', ['top-navigation-text'])
	createText.innerHTML = textNahoreOtvoreno
	topNavigationTools.appendChild(createText)
}

const movelanguagesMenu = () => {
	const languagesMenu = document.querySelector('.top-navigation-tools .languagesMenu')
	const topNavMenu = document.querySelector('.top-navigation-menu')
	if (!languagesMenu) return
	if (!topNavMenu) return
	topNavMenu.appendChild(languagesMenu)
}

const addLinksToHeader = () => {
	let redNotice

	if (typeof tlacitkoNahoreCervene !== 'undefined') {
		redNotice = createElement('div', ['red-notice'])
		const link = createElement('a', ['btn'], tlacitkoNahoreCervene?.text)
		link.href = tlacitkoNahoreCervene?.odkaz
		redNotice.appendChild(link)
	}
	if (window.innerWidth < 768) {
		const header = document.querySelector('#header')
		if (header && typeof redNotice !== 'undefined') header.prepend(redNotice)
	} else {
		const siteName = document.querySelector('.site-name-wrapper')
		const topBTnWrapper = createElement('div', ['top-btn-wrapper'])
		if (typeof tlacitkoNahorePrvni !== 'undefined') {
			const firstLink = createElement('a', ['btn', 'btn-primary'], tlacitkoNahorePrvni?.text)
			firstLink.href = tlacitkoNahorePrvni?.odkaz
			topBTnWrapper.appendChild(firstLink)
		}
		if (typeof tlacitkoNahoreDruhe !== 'undefined') {
			const secondLink = createElement('a', ['btn', 'btn-secondary', 'btn-paw'], tlacitkoNahoreDruhe?.text)
			secondLink.href = tlacitkoNahoreDruhe?.odkaz
			topBTnWrapper.appendChild(secondLink)
		}
		if (siteName) {
			if (typeof redNotice !== 'undefined') siteName.after(redNotice)
			if (typeof topBTnWrapper !== 'undefined') siteName.after(topBTnWrapper)
		}
	}
}

addTextToTopNav()
movelanguagesMenu()
moveLoginToNavigationButtons()
moveHamburgerToNavigationButtons()
moveTopNavToNavigationMobile()
setHeaderTopHeightVariable()
setStickyHeader()
createMenuLevel2Wrap()
addLinksToHeader()
// moveBannerToMenu()
// moveNavigationToHeaderTop()
// handleTopBarCurrency()

// CAROUSEL
createCarouselDots()
// END OF COMONLY USED
if (document.body.classList.contains('id-29')) {
	handleContactForm()
}

// CATEGORY
if (dataLayer[0].shoptet.pageType === 'category') {
	const categoryContentWrapper = document.querySelector('.category-content-wrapper')
	if (categoryContentWrapper) {
		handleTopProducts(categoryContentWrapper)

		document.addEventListener('ShoptetDOMContentLoaded', () => {
			const categoryContentWrapper2 = document.querySelector('.category-content-wrapper')
			handleTopProducts(categoryContentWrapper2)
		})
	}
}

// PRODUCT DETAIL
if (dataLayer[0].shoptet.pageType === 'productDetail') {
	// moveFlagsToImage()
	handleProductTop()
	document.addEventListener('ShoptetDOMContentLoaded', handleProductTop)
	createAddToCartWrapper()
	createDeliveryWrapper()
	// createProductInfoWrapper()
	handlePDescLink()
	appendflagsExtraToFlags()
	handleThumbnailArrows()
	let detailParametersVariants = document.querySelectorAll('.detail-parameters td > select')
	if (detailParametersVariants.length) {
		detailParametersVariants.forEach((variant) => {
			if (variant.hasAttribute('data-parameter-id')) {
				let variantId = variant.getAttribute('data-parameter-id')
				if (variantId) {
					variantsHandler(variantId)
				}
			}
		})
	}
	document.addEventListener('dkLabFavouriteProductsLoaded', handleFavoritesIcon)
}

// BLOG
if (document.body.classList.contains('type-posts-listing')) {
	addLinkToArticles()
	moveBlogTimeToImg()
}

if (document.body.classList.contains('type-post')) {
	const newsItemDetail = document.querySelector('.news-item-detail')
	if (newsItemDetail) {
		const nextPrev = document.querySelector('.next-prev')
		if (nextPrev) {
			newsItemDetail.after(nextPrev)
			const nextPrevLinks = nextPrev.querySelectorAll('a')
			if (nextPrevLinks.length) {
				for (let link of nextPrevLinks) {
					link.classList.add('btn-primary')
				}
			}
		}
	}
	const imgFrame = document.querySelector('.news-item-detail .img-frame')
	if (imgFrame && newsItemDetail) newsItemDetail.after(imgFrame)
}

// add dog leading to FAQ
const addFAQdog = () => {
	const dogFAQWrapper = createElement('div', ['dog-faq-wrapper'])
	dogFAQWrapper.innerHTML = `
	<a href="/casto-kladene-otazky--faq/" class="dog-faq">
	<div class="question">Ako ti môžem pomôcť?</div>
	<img src="/user/documents/upload/miranda/dogFAQ.png" alt="FAQ" width="100" height="100">
	</a>
	`
	const overallWrapper = document.querySelector('.overall-wrapper')
	if (overallWrapper) overallWrapper.appendChild(dogFAQWrapper)
	// when the scrolling reaches 30px before the end of the page, the dog will disappear
	const dogFAQ = document.querySelector('.dog-faq')
	if (dogFAQ) {
		window.addEventListener('scroll', () => {
			if (window.scrollY + window.innerHeight >= document.body.offsetHeight - 30) {
				dogFAQ.style.display = 'none'
			} else {
				dogFAQ.style.display = 'flex'
			}
		})
	}
}
addFAQdog()
